<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="mb-1">Finance Reporting</h4>
      <p class="text-muted mb-0">
        P&amp;L reporting for completed SwipFx matches, spreads, fees, and USD valuation.
      </p>
    </div>

    <button class="btn btn-outline-primary" (click)="exportCsv()" [disabled]="exporting">
      <span *ngIf="exporting" class="spinner-border spinner-border-sm me-1"></span>
      Download CSV
    </button>
  </div>

  <div class="finance-card p-3 mb-3">
    <div class="row g-3 align-items-end">
      <div class="col-md-3">
        <label class="form-label">From date</label>
        <input type="date" class="form-control" [(ngModel)]="filters.fromDate" [max]="today">
      </div>

      <div class="col-md-3">
        <label class="form-label">To date</label>
        <input type="date" class="form-control" [(ngModel)]="filters.toDate" [max]="today">
      </div>

      <div class="col-md-2">
        <label class="form-label">Currency</label>
        <input type="text" class="form-control" placeholder="NGN" [(ngModel)]="filters.currency">
      </div>

      <div class="col-md-2">
        <label class="form-label">Currency pair</label>
        <input type="text" class="form-control" placeholder="USD/NGN" [(ngModel)]="filters.currencyPair">
      </div>

      <div class="col-md-2 d-flex gap-2">
        <button class="btn btn-primary w-100" (click)="applyFilters()" [disabled]="loading">
          Apply
        </button>
        <button class="btn btn-light border" (click)="resetFilters()">
          Reset
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border text-primary"></div>
  </div>

  <ng-container *ngIf="!loading && report">
    <div class="row g-3 mb-3">
      <div class="col-md-3">
        <div class="finance-card p-3 h-100">
          <div class="label">Gross spread captured</div>
          <div class="value">{{ formatMoney(report.summary.grossSpreadUsd) }}</div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="finance-card p-3 h-100">
          <div class="label">Fee leakage</div>
          <div class="value">{{ formatMoney(report.summary.feeLeakageUsd) }}</div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="finance-card p-3 h-100">
          <div class="label">Net trading profit</div>
          <div class="value">{{ formatMoney(report.summary.netTradingProfitUsd) }}</div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="finance-card p-3 h-100">
          <div class="label">Completed matches</div>
          <div class="value">{{ report.summary.completedMatchesCount }}</div>
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-lg-8">
        <div class="finance-card p-3 h-100">
          <div class="finance-section-title mb-3">Profit trend</div>

          <div class="chart-box" *ngIf="profitTrendChart">
            <canvas
              baseChart
              [type]="'line'"
              [data]="profitTrendChart">
            </canvas>
          </div>

          <p *ngIf="!report.profitTrend.length" class="text-muted mb-0">
            No profit trend data yet.
          </p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="finance-card p-3 h-100">
          <div class="finance-section-title mb-3">Reference rates</div>

          <form (ngSubmit)="saveRate()" class="mb-3">
            <div class="row g-2">
              <div class="col-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="NGN"
                  [(ngModel)]="rateForm.currencyCode"
                  name="currencyCode">
              </div>

              <div class="col-8">
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="rateForm.rateDate"
                  [max]="today"
                  name="rateDate">
              </div>

              <div class="col-6">
                <input
                  type="number"
                  step="0.000000000001"
                  class="form-control"
                  placeholder="Rate to USD"
                  [(ngModel)]="rateForm.rateToUsd"
                  name="rateToUsd">
              </div>

              <div class="col-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Source"
                  [(ngModel)]="rateForm.source"
                  name="source">
              </div>

              <div class="col-12">
                <button class="btn btn-primary w-100" type="submit" [disabled]="savingRate">
                  <span *ngIf="savingRate" class="spinner-border spinner-border-sm me-1"></span>
                  Save rate
                </button>
              </div>
            </div>
          </form>

          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Currency</th>
                  <th>Date</th>
                  <th class="text-end">Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rate of rates.slice(0, 6)">
                  <td>{{ rate.currencyCode }}</td>
                  <td>{{ rate.rateDate }}</td>
                  <td class="text-end">{{ formatNumber(rate.rateToUsd) }}</td>
                </tr>
                <tr *ngIf="!rates.length">
                  <td colspan="3" class="text-muted">No rates found.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-lg-6">
        <div class="finance-card p-3 h-100">
          <div class="finance-section-title mb-3">Spread by currency</div>

          <div class="chart-box" *ngIf="spreadByCurrencyChart">
            <canvas
              baseChart
              [type]="'bar'"
              [data]="spreadByCurrencyChart">
            </canvas>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Currency</th>
                  <th class="text-end">Native spread</th>
                  <th class="text-end">USD value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of report.spreadByCurrency">
                  <td>{{ item.currencyCode }}</td>
                  <td class="text-end">{{ formatNumber(item.grossSpreadNative) }}</td>
                  <td class="text-end">{{ formatMoney(item.grossSpreadUsd) }}</td>
                </tr>
                <tr *ngIf="!report.spreadByCurrency.length">
                  <td colspan="3" class="text-muted">No spread data yet.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="finance-card p-3 h-100">
          <div class="finance-section-title mb-3">Profit by currency pair</div>

          <div class="chart-box" *ngIf="profitByPairChart">
            <canvas
              baseChart
              [type]="'bar'"
              [data]="profitByPairChart">
            </canvas>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Pair</th>
                  <th class="text-end">Gross spread</th>
                  <th class="text-end">Fee leakage</th>
                  <th class="text-end">Net profit</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of report.profitByPair">
                  <td>{{ item.currencyPair }}</td>
                  <td class="text-end">{{ formatMoney(item.grossSpreadUsd) }}</td>
                  <td class="text-end">{{ formatMoney(item.feeLeakageUsd) }}</td>
                  <td class="text-end">{{ formatMoney(item.netTradingProfitUsd) }}</td>
                </tr>
                <tr *ngIf="!report.profitByPair.length">
                  <td colspan="4" class="text-muted">No pair data yet.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="finance-card p-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="finance-section-title">Trade profit snapshots</div>
        <small class="text-muted">Only completed matches are included.</small>
      </div>

      <div *ngIf="loadingTrades" class="text-center py-3">
        <div class="spinner-border spinner-border-sm text-primary"></div>
      </div>

      <div class="table-responsive" *ngIf="!loadingTrades">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th>Matched At</th>
              <th>Pair</th>
              <th class="text-end">Spread A</th>
              <th class="text-end">Spread B</th>
              <th class="text-end">Gross USD</th>
              <th class="text-end">Fee Leakage</th>
              <th class="text-end">Net Profit</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let trade of trades">
              <td>{{ formatShortDate(trade.matchTimestamp) }}</td>
              <td>{{ trade.currencyA }}/{{ trade.currencyB }}</td>
              <td class="text-end">{{ formatNumber(trade.spreadA) }} {{ trade.currencyA }}</td>
              <td class="text-end">{{ formatNumber(trade.spreadB) }} {{ trade.currencyB }}</td>
              <td class="text-end">{{ formatMoney(trade.grossSpreadUsd) }}</td>
              <td class="text-end">{{ formatMoney(trade.feeLeakageUsd) }}</td>
              <td class="text-end fw-semibold">{{ formatMoney(trade.netTradingProfitUsd) }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="trade.isUsdValuationComplete ? 'bg-success' : 'bg-warning text-dark'">
                  {{ trade.isUsdValuationComplete ? 'Valued' : 'Missing rate' }}
                </span>
              </td>
            </tr>

            <tr *ngIf="!trades.length">
              <td colspan="8" class="text-muted text-center py-4">
                No completed trade snapshots found for this filter.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

        <app-footer></app-footer>
    </main>
</div>
